export default __webpack_public_path__ + "static/media/error-icon.4a5834df.png";